import {useUser} from "../../../../misc/Permission";
import React, {useCallback, useContext, useState} from "react";
import {PendingHardware} from "./PendingHardware";
import {WorkingHardware} from "./WorkingHardware";
import {cellInActive} from "../pricing/cellconst";
import {ChangePreviewContext} from "../ShopDrawingChangePreview";
import {HardwareViewModeContext} from "../../quote/hardware/HardwareViewMode";
import {useProject} from "../ProjectName";
import {useIsQuote} from "../../quote/QuoteContainer";
import {useAlternative} from "../../quote/alternative/Alternative";

export const colCount = 12;
export const indentWidth = 30;

export function HardwareTable() {

    const viewMode = useContext(HardwareViewModeContext).viewMode;
    const previewChangeset = useContext(ChangePreviewContext);
    const [hidePending, setHidePending] = useState(false);
    const u = useUser();
    const proj = useProject();
    const isQuoteMode = useIsQuote();
    const alt = useAlternative();
    const lockedQuoteMode = isQuoteMode && proj?.quoteLockedHardware === alt
    const [search, setSearch] = useState("");

    const onFilter = useCallback((search: string, hidePending: boolean) => {
        setHidePending(hidePending);
        setSearch(search);
    }, [])

    if(!u) return null;

    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "stretch", backgroundColor: cellInActive}}>
            <WorkingHardware onFilter={onFilter} />
            {hidePending || previewChangeset.enabled || viewMode !== "default" || lockedQuoteMode ? null : <PendingHardware search={search} />}
        </div>
    )
}